export const paperSizes = [
  { label: 'B6 (125 mm x 176 mm)', value: 'B6 (125 mm x 176 mm)' },
  { label: 'B5 (176 mm x 250 mm)', value: 'B5 (176 mm x 250 mm)' },
  { label: 'A4 (210 mm x 297 mm)', value: 'A4 (210 mm x 297 mm)' },
  { label: 'B4 (250 mm x 353 mm)', value: 'B4 (250 mm x 353 mm)' },
  { label: 'A3 (297 mm x 420 mm)', value: 'A3 (297 mm x 420 mm)' },
  { label: 'B3 (353 mm x 500 mm)', value: 'B3 (353 mm x 500 mm)' },
  { label: 'A2 (420 mm x 594 mm)', value: 'A2 (420 mm x 594 mm)' },
  { label: 'B2 (500 mm x 707 mm)', value: 'B2 (500 mm x 707 mm)' },
  { label: 'A1 (594 mm x 841 mm)', value: 'A1 (594 mm x 841 mm)' },
  { label: 'B1 (707 mm x 1000 mm)', value: 'B1 (707 mm x 1000 mm)' },
  { label: 'A0 (841 mm x 1189 mm)', value: 'A0 (841 mm x 1189 mm)' },
  { label: 'B0 (1000 mm x 1414 mm)', value: 'B0 (1000 mm x 1414 mm)' },
];
